export default __webpack_public_path__ + "static/GT-America-Mono-Regular-Italic-42dedf47a4fdb745eb3fedd994089f74.ttf";